import { string } from 'yup'
import { safify } from '../utils/safify'

export const promotion = string()
  .default('')
  .meta({ label: 'Promotion', placeholder: 'Add promo code e.g., “Welcome10”', snippets: true, autoFill: true })
  .transform(safify)
